/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_ngcontent-%COMP%]:root{--mmi-background-color:#eef2f5;--mmi-bottombar-bg-color:#4e5b61;--mmi-bottombar-bg-darken:#354248;--mmi-primary-btn:#F3953F;--mmi-secondary-btn:#58a4c0;--mmi-btn-colour-3:#58a4c0;--mmi-btn-colour-4:#58a4c0;--green-color:#54D89F;--red-color:#EC506E;--login-page-bg-color:#4e5b61}[_nghost-%COMP%]     dropzone.dropzone-container{height:100%}[_nghost-%COMP%]     dropzone .dropzone.dz-wrapper .dz-message{height:100%;margin:0;border-radius:8px;border:2px dashed rgba(81,116,170,.5)}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/core/achoo-dropzone/achoo-dropzone.component.scss.shim.ngstyle.js.pre-build-optimizer.js